import { createRootRouteWithContext, Outlet, useRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useSession, logout } from '../lib/session';
import { Button } from '../components/ui/Button';
import { OfflineBanner } from '../components/ui/OfflineBanner';
import { SidebarShell, SidebarToggle } from '../components/layout/Sidebar';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
});

function RootLayout() {
  const session = useSession();
  const router = useRouter();
  const [drawerOpen, setDrawerOpen] = useState(false);

  async function handleLogout() {
    await logout();
    await session.refetch();
    await router.navigate({ to: '/login' });
  }

  const isLoginPage = router.state.location.pathname === '/login';

  if (isLoginPage || !session.data) {
    return (
      <div className="min-h-screen">
        <OfflineBanner />
        <main className="mx-auto max-w-7xl px-6 py-6">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-slate-50">
      <SidebarShell open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="flex flex-1 flex-col">
        <OfflineBanner />
        <header className="flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-2 lg:px-6">
          <SidebarToggle onClick={() => setDrawerOpen(true)} />
          <div className="ml-auto flex items-center gap-3 text-sm text-slate-600">
            <span>
              {session.data.email} <span className="text-slate-400">({session.data.role})</span>
            </span>
            <Button variant="ghost" onClick={handleLogout}>
              Abmelden
            </Button>
          </div>
        </header>
        <main className="flex-1 overflow-auto px-4 py-6 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
